import { useRef } from "react"
import { cx } from "@emotion/css"
import { Tooltip } from "@material-ui/core"
import { getPrefixedClassNames, styles } from "./styles"
import { ColumnDefinition, Area } from "./types"
import { DEFAULT_MIN_COLUMN_WIDTH, DEFAULT_MAX_COLUMN_WIDTH } from "./constants"
import { ReactComponent as InfoGrayIcon } from "assets/alert/info-gray.svg"

import { ColumnResizer } from "./ColumnResizer"
import { useTableContext } from "./context"

type HeaderCellProps = {
  column: ColumnDefinition
  area: Area
}

export function HeaderCell(props: HeaderCellProps) {
  const { column, area } = props
  const {
    id: columnId,
    width,
    align = "spaceBetween",
    dataKey,
    Header,
    resizable = false,
    maxWidth,
    minWidth,
  } = column

  const ref = useRef<HTMLDivElement | null>(null)

  const { columnManager: cm, onColumnResize: onColumnResizeProp } =
    useTableContext()

  const handleResizerDone = (w: number) => {
    cm.onColumnResize(w, column)
    onColumnResizeProp && onColumnResizeProp(w, column)
  }

  return (
    <div
      ref={ref}
      data-grid-header-cell
      data-column-id={columnId}
      role="columnheader"
      className={cx(
        styles.cell,
        styles.headerCell,
        styles.aligns[align],
        getPrefixedClassNames("cell", "header-cell", `header-cell--${area}`),
      )}
      style={{ width }}
    >
      {Header === null || typeof Header === "string" ? (
        <span className={styles.cellText}>{Header}</span>
      ) : (
        <Header id={columnId} dataKey={dataKey} align={align} />
      )}
      {column?.infoTooltipTitle && (
        <Tooltip title={column.infoTooltipTitle}>
          <InfoGrayIcon />
        </Tooltip>
      )}
      {resizable ? (
        <ColumnResizer
          cellRef={ref}
          minWidth={minWidth ?? DEFAULT_MIN_COLUMN_WIDTH}
          maxWidth={maxWidth ?? DEFAULT_MAX_COLUMN_WIDTH}
          onDone={handleResizerDone}
        />
      ) : null}
    </div>
  )
}
